<template>
  <div class="forgot-password">
    <Banner
      :title="'FORGOT PASSWORD'"
      :class-banner="'common-banner'"
    />
    <div class="forgot-password__title">
      Please complete below form to forgot password. All fields are mandatory
    </div>
    <div class="forgot-password__input-cell-phone forgot-password__input-common">
      <b-input-group>
        <template #prepend>
          <b-input-group-text >{{callingCode}}</b-input-group-text>
        </template>
        <b-form-input
          type="number"
          v-model="phone"
          placeholder="Cellphone"
        />
      </b-input-group>
    </div>
    <div class="forgot-password__button-submit">
      <b-button @click="forgotPassword">Forgot Password</b-button>
    </div>
    <div class="forgot-password__forgot-register">
      <div @click="$router.push('/login')" class="forgot-password-bottom">Login</div>
      <div class="line">|</div>
      <div @click="$router.push('/register')" class="register-bottom">Register</div>
    </div>
  </div>
</template>
<script>
import Banner from '@/components/common/banner';
import authService from '@/services/auth.service';
const CALLINGCODE = process.env.VUE_APP_CALLING_CODE;

export default {
  components: {
    Banner
  },
  data() {
    return {
      callingCode: "+" + CALLINGCODE,
     phone: ''
    }
  },
  methods: {
    forgotPassword() {
      authService.forgotPassword(this.phone).then((res) => {
        if (res.status === 'success') {
          this.$bvToast.toast('Forgot password successfully', {
            title: 'Successfully',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000,
          });
        } else {
          const message = res.message;
          this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        }

      },
      () => {
        this.$bvToast.toast('Forgot password! Please try again', {
          title: 'Failed',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        })
      });
    }
  }
}
</script>
